<template lang="pug">
  v-container(grid-list-xl, text-xs-center)
    v-layout(row, wrap)
      v-flex(xs12, style='height: auto;margin-top: 20px;')
        img(src='../assets/logo.png', style='width: 500px;height: auto;')
      v-flex(xs6, offset-xs3)
        h1 Inicio de Sesión
        v-form(enctype="multipart/form-data")
          v-text-field(id="username"
            v-model="form.email"
            prepend-icon="chevron_right",
            required
            label="Usuario:")

          v-text-field(id="password"
            type="password"
            v-model="form.password"
            prepend-icon="chevron_right",
            required
            label="Contraseña:")

          v-spacer
          v-btn(color='rgb(2 2 63)', style='color:white' @click.native='login') Entrar
</template>

<script>
import Api from "@/services/methods";
import { server, port } from "@/services/environment";
export default {
  name: "mLogin",
  data: () => ({
    ruta: server + ":" + port,
    settings: {},
    form: {
      id: 1,
      token: "a82kddn282020",
      email: null,
      password: null
    }
  }),
  created() {
    this.initialize();
    if (this.$store.state.isUserLoggedIn) {
      this.$router.push("/");
    }
  },
  methods: {
    initialize() {},
    login() {
      Api.post("empresa/login", this.form)
        .then(res => {
          if (res.data.status == "Success") {
            this.$store.dispatch("login", res.data);
            this.$cookies.set("tokenSMS", res.data.token, "5D", "");
            window.location.href = "/home";
          } else {
            this.$swal.fire(
              "Oops...",
              "Error encontrado, usuario o contraseña incorrecta.",
              "error"
            );
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
